import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import classNames from "lib/classNames";

const ConditionCheck = ({ checkout_condition_text, checkout_condition_color, Utils, rtl ,isTermsAccepted, setIsTermsAccepted, shakeClass}) => {
	

	return (
		<div className={classNames(`py-3 flex items-start justify-center ${shakeClass}`)}>
			<button
				className={classNames(
					"w-4 h-4 flex-shrink-0 rounded border-2 cursor-pointer flex items-start justify-center",
					rtl ? "ml-1" : "mr-1"
				)}
				style={{
					marginTop: 2,
					color: Utils.formatColor(checkout_condition_color),
					borderColor: Utils.formatColor( checkout_condition_color),
					width: "fit-content",
					height: "fit-content",
					minHeight: "20px", // popular theme issue
					padding: 1
				}}
				onClick={() => setIsTermsAccepted(!isTermsAccepted)}
			>
				<svg
					aria-hidden="true"
					focusable="false"
					data-icon="check"
					style={{ width: 13, height: 13 }}
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 512 512"
					className={classNames({ "opacity-0": !isTermsAccepted })}
				>
					<path
						fill="currentColor"
						d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
					></path>
				</svg>
			</button>
			<div
				dangerouslySetInnerHTML={{
					__html: checkout_condition_text
				}}
			/>
		</div>
	);
};


export default ConditionCheck;
